export default __webpack_public_path__ + "static/img/vogue_scene_animated_0677.6df7fd4.webp";